import React from 'react';
import { Modal } from "react-bootstrap";
import ErrorMessage from './ErrorMessage';
import { diffCheck } from "../../../../../../util/Helpers";
import { InstrumentIcon } from '../../../../../../util/Icons';


const UpdateInstrument = ({ show, action: { action, error, data }, onHide }) => {
    const { meta: oldData, ...newData } = data

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                        <InstrumentIcon />
                    </span> {action}
                </Modal.Title>
                <button type="button" className="close" onClick={onHide}>
                    <span aria-hidden="true" className="d-block">×</span>
                    <span className="sr-only">Close</span>
                </button>
            </Modal.Header>
            <Modal.Body
                className="px-10 py-2"
            >
                <ErrorMessage {...{ error }} />
                <div className="row">
                    <div className="col-lg-3 py-4">
                        <h6>Symbol</h6>
                        <span className="text-muted">{diffCheck(oldData?.symbol, newData?.symbol)}</span>
                    </div>
                    <div className="col-lg-9 py-4">
                        <h6>Name</h6>
                        <span className="text-muted">{diffCheck(oldData?.name, newData?.name)}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6>Description</h6>
                        <span className="text-muted">{diffCheck(oldData?.description, newData?.description)}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6>List Date</h6>
                        <span className="text-muted">{diffCheck(oldData?.listdate, newData?.listdate)}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Category</h6>
                        <span className="text-muted">{diffCheck(oldData?.category, newData?.category)}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>CEO</h6>
                        <span className="text-muted">{diffCheck(oldData?.meta?.ceo, newData?.metadata?.ceo)}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6>Phone</h6>
                        <span className="text-muted">{diffCheck(oldData?.meta?.phone, newData?.metadata?.phone)}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Address</h6>
                        <span className="text-muted">{diffCheck(oldData?.meta?.address, newData?.metadata?.address)}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6>Image URL</h6>
                        <span className="text-muted">{diffCheck(oldData?.url, newData?.url)}</span>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <button
                    type="button"
                    onClick={onHide}
                    className="btn btn-primary btn-elevate px-5"
                >
                    Okay
                </button>
            </Modal.Footer>
        </Modal>
    )
}

export default UpdateInstrument;